<template>
  <div class="p-m-3 sp-page">
    <MockBanner />
    <div v-if="!project"><h3>Project not found</h3></div>
    <div v-else>
      <div class="sp-row">
        <div>
          <span class="sp-muted">Project at
            <span class="sp-link" @click="$router.push('/sitesProjects/sites/' + site.id)">{{ site.name }}</span>,
            {{ [site.address1, site.town, site.postCode].filter(Boolean).join(', ') }}
          </span>
          <h2 style="margin: 0;">{{ project.name }} <span :class="'sp-chip ' + status" style="font-size: 13px; vertical-align: middle;">{{ status }}</span></h2>
          <div v-if="project.notes" class="sp-muted">{{ project.notes }}</div>
        </div>
        <span class="sp-spacer"></span>
        <Button label="Add another contractor's quote" icon="pi pi-user-plus" class="p-button-outlined" disabled
                title="New enquiry on this project for another customer (e.g. a sub-contractor). Description, address and product type are copied." />
        <Button label="Add another product type" icon="pi pi-clone" class="p-button-outlined" disabled
                title="New enquiry on this project for the same customer and contact, with a different product type." />
        <Button label="Merge into another project" icon="pi pi-sitemap" class="p-button-outlined p-button-secondary" disabled
                title="Managers and Admin: moves every enquiry to the other project and removes this one." />
      </div>

      <div class="sp-row p-mt-3">
        <div class="sp-kpi">
          <div class="label">Counted in the quote bank</div>
          <div class="value">{{ money(totals.counted) }}</div>
          <div class="hint">Each product type once: {{ ruleText }}, or the won value once won</div>
        </div>
        <div class="sp-kpi">
          <div class="label">Live quotes added up (today's quote bank)</div>
          <div class="value sp-muted">{{ money(totals.liveSum) }}</div>
          <div class="hint">Over-counted today: {{ money(totals.liveSum - totals.counted) }}</div>
        </div>
        <div class="sp-kpi"><div class="label">Enquiries / customers</div><div class="value">{{ totals.nEnquiries }} / {{ totals.nCustomers }}</div></div>
      </div>

      <div v-for="line in lines" :key="line.productType" class="p-card p-p-3 p-mt-3">
        <div class="sp-row">
          <h4 style="margin: 0;">{{ line.productType }}</h4>
          <span class="sp-muted">{{ line.nCustomers }} customer(s) quoting · branches {{ line.branches }}</span>
          <span class="sp-spacer"></span>
          <span v-if="line.nQuotes > 1" class="sp-muted">Low {{ money(line.low) }} · Average {{ money(line.avg) }} · High {{ money(line.high) }}</span>
          <span class="sp-chip live" style="font-size: 13px;">Counted {{ money(line.countedValue) }}<span v-if="line.basis"> ({{ line.basis }}<span v-if="line.nQuotes > 1"> of {{ line.nQuotes }}</span>)</span></span>
        </div>
        <table class="sp-table p-mt-2">
          <thead>
            <tr><th>Quote No</th><th>Customer</th><th>Role</th><th>Branch</th><th>Sales Exec</th><th>Enquiry Type</th><th>Status</th><th class="sp-money">Value £</th><th>Created</th><th>In the project value?</th></tr>
          </thead>
          <tbody>
            <tr v-for="e in line.rows" :key="e.quoteNo">
              <td><span class="sp-link">{{ e.quoteNo }}</span></td>
              <td>{{ e.customer }}</td>
              <td><span v-if="e.role" class="sp-chip role">{{ e.role }}</span></td>
              <td>{{ e.branch }}</td>
              <td>{{ e.salesExec }}</td>
              <td>{{ e.enqType }}</td>
              <td><span :class="'sp-chip ' + e.status">{{ e.status }}</span></td>
              <td :class="'sp-money ' + (inValue(e) ? '' : 'sp-strike')">{{ money(e.value) }}</td>
              <td>{{ e.created }}</td>
              <td>
                <span v-if="dupText(e)" class="sp-chip dup" :title="dupText(e)">{{ dupText(e) }}</span>
                <span v-else-if="inValue(e)">Yes</span>
                <span v-else class="sp-muted">{{ e.value ? 'No (' + e.status.toLowerCase() + ')' : 'No (not quoted yet)' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MockBanner from './MockBanner.vue'
import { projectById, siteById, productLines, projectTotals, projectStatus, isLive, s2Excluded, settings, money } from './mockData'

export default {
  name: 'SpProjectDetail',
  components: { MockBanner },
  computed: {
    project() { return projectById(+this.$route.params.id) },
    site() { return this.project && siteById(this.project.siteId) },
    lines() { return productLines(this.project.id) },
    totals() { return projectTotals(this.project.id) },
    status() { return projectStatus(this.project.id) },
    ruleText() { return { average: 'the average of the live quotes', highest: 'the highest live quote', lowest: 'the lowest live quote' }[settings.valueRule] }
  },
  methods: {
    money,
    inValue(e) { return isLive(e) && !!e.value && !s2Excluded(e) },
    dupText(e) {
      const partner = e.dupOf || (this.project && this.lines.flatMap(l => l.rows).find(x => x.dupOf === e.quoteNo) || {}).quoteNo
      if (!partner) return ''
      return s2Excluded(e)
        ? 'Duplicate of ' + partner + ' (same customer, other branch): not counted'
        : 'Duplicate pair with ' + partner + ': this one counts (' + settings.s2Counts + ')'
    }
  }
}
</script>

<style scoped>
@import './sitesProjects.css';
</style>
